import { Component, OnDestroy, OnInit } from '@angular/core';
import { StoreService } from '../../services/store.service';
import { Subscription, tap } from 'rxjs';
import { ProjectsService } from '../../services/projects.service';
import { PowerLineConfig } from '../../model/general.model';

@Component({
  selector: 'app-map-page',
  templateUrl: './map-page.component.html',
  styleUrls: ['./map-page.component.scss']
})
export class MapPageComponent implements OnInit, OnDestroy {

  config: PowerLineConfig;
  showMap = true;
  sub = new Subscription();
  constructor(
    public store: StoreService,
    private projectsService: ProjectsService
  ) {
  }

  ngOnInit(): void {
    this.listenToProjectChange();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private getData(): void {
    this.store.showLoader();
    this.projectsService.getMapData(this.store.selectedProject.id).pipe(
      tap(data => {
        this.config = { ...data, onlyTasks: this.store.powerLineHidden, zoom: true }
        this.store.setPowerLineConfig(this.config);
        this.store.hideLoader();
      }),
    ).subscribe()
  }

  private listenToProjectChange(): void {
    this.sub.add(
      this.store.projectChanged$.subscribe(() => this.projectChanged())
    )
  }

  private projectChanged() {
    this.showMap = false;
    setTimeout(() => {
      this.getData();
      this.showMap = true;
    }, 0);
  }

  togglePowerLineVisibility() {
    const onlyTasks = this.store.powerLineHidden;
    this.store.setPowerLineConfig( {...this.config, onlyTasks, zoom: false })
  }
}
